/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PositionCto } from '../../models/position-cto';

export interface GetJobAsync_1$Json$Params {
  positionId: number;
}

export function getJobAsync_1$Json(http: HttpClient, rootUrl: string, params: GetJobAsync_1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
  const rb = new RequestBuilder(rootUrl, getJobAsync_1$Json.PATH, 'get');
  if (params) {
    rb.path('positionId', params.positionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PositionCto>;
    })
  );
}

getJobAsync_1$Json.PATH = '/job/{positionId}';
